import { render, staticRenderFns } from "./ProductPatterns.vue?vue&type=template&id=d877cc0a&scoped=true&"
import script from "./ProductPatterns.vue?vue&type=script&lang=js&"
export * from "./ProductPatterns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d877cc0a",
  null
  
)

export default component.exports